import { render, staticRenderFns } from "./AnzeraLifeDropdown.vue?vue&type=template&id=6cc1106c&scoped=true"
import script from "./AnzeraLifeDropdown.vue?vue&type=script&lang=js"
export * from "./AnzeraLifeDropdown.vue?vue&type=script&lang=js"
import style0 from "./AnzeraLifeDropdown.vue?vue&type=style&index=0&id=6cc1106c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc1106c",
  null
  
)

export default component.exports